















  import { Component, Vue } from 'nuxt-property-decorator'
  import { namespace } from 'vuex-class'
  const plugins = namespace('plugins')
  @Component({
    components: {
      OneExternalIframePlugin: () => import('~/components/molecules/plugins/OneExternalIframePlugin.vue'),
    },
  })
  export default class OneFullScreenPluginModal extends Vue {
    @plugins.State showPluginModal: any
    @plugins.State modalComponentId: any
    @plugins.Mutation hidePluginModal: any

    get isMobile() {
      return this.$utils.isMobile(this.$mq)
    }

    onClose() {
      this.hidePluginModal()
    }
  }
